import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CredentialCard from "../CredentialExplorer/credentialCard";
import GoogleAnalytics from "../GA";
import config from "../../config";

function CredentialOfferNotification(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("Loading...");

  const [searchParams] = useSearchParams();
  

  // Write all params to object init_request
  const init_request = {};
  searchParams.forEach((value, key) => {
    init_request[key] = value;
  });

  const [issuanceData, setIssuanceData] = useState({});
  useEffect(() => {
    setIsLoading(true);
    fetch(init_request.credential_offer_uri)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error in API Issue");
        }
        return response.json();
      })
      .then((data) => {     
        let brandId = data.credential_issuer.split("/").pop();        
        if (data.credentials[0].types != null) {
          fetch(config.issuerMetadataEndpoint+"/"+brandId)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Error fetching from issuer metadata endpoint");
              }
              return response.json();
            })
            .then((issuerMetadata) => {
              let types = data.credentials[0].types;
              issuerMetadata.credential_supported.map((credential) => {
                if (
                  JSON.stringify(types) === JSON.stringify(credential.types)
                ) {
                  setIssuanceData({
                    issuer: issuerMetadata.display.name,
                    credential: credential.display.name,
                  });
                }
              });
            });
        }
        setIsLoading(false);
      });
  }, []);

  // On user consent with issuance
  function clickAcceptHandler() {
    // GA4 Creation of new credential approved
    GoogleAnalytics("created_new_credential", "User");

    let linkDestination =
      window.location.origin +
      "/api/v1/credential_offer?" +
      searchParams.toString();
    try {
      window.location.href = linkDestination;
    } catch (error) {        
      console.log(error);
    }
  }

  function clickRejectHandler() {
    // GA4 Creation of new credential approved
    GoogleAnalytics("rejected_creation_of_new_credential", "User");
    props.onReject();
  }
  return (
    <div className="container">
      {isLoading && (
        <div className="messages">
          <h2>{message}</h2>
        </div>
      )}
      {!isLoading && (
        <div className="messages">
          <p className="light">
            Do you want to add the following credential to your wallet?
          </p>
          <br />
          <CredentialCard
            name={issuanceData.credential}
            issuer={issuanceData.issuer}
            disableClick={true}
          />

          <p>
            "{issuanceData.credential}" will be issued by {issuanceData.issuer}
          </p>

          <button
            className="btn btn-primary"
            style={{ width: "190px", marginRight: "20px" }}
            onClick={clickAcceptHandler}
          >
            Accept
          </button>
          <button
            className="btn btn-secondary"
            style={{ width: "190px" }}
            onClick={clickRejectHandler}
          >
            Reject
          </button>
        </div>
      )}
    </div>
  );
}
export default CredentialOfferNotification;
